import React, {useCallback} from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {Tooltip} from 'components/ui-kit/Tooltip';

import {colors, breakpoint, font} from 'theme';

const additionalStyles = `
    text-align: left;
    max-width: 250px;
    border-radius: 8px;
    opacity: 1 !important;
    `;

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;
const Code = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
    margin-bottom: 4px;
`;
const Name = styled.div<{isSelected?: boolean}>`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 300px;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

export const CustomHsnCodes = (props: OptionProps<any, false>) => {
    const {data} = props;
    const itemData: {
        city: string;
        label: string;
        postalCode: string;
        value: string;
        name: string;
    } = {...data};
    return (
        <components.Option {...props}>
            <Code isSelected={props.isSelected}>{itemData.value}</Code>
            <Label isSelected={props.isSelected}>{itemData.label}</Label>
            <Tooltip
                id={`${itemData.value}-tooltip`}
                place={'top'}
                backgroundColor="white"
                textColor="#111111"
                additionalStyles={
                    additionalStyles +
                    'box-shadow: 0px 0px 6px rgba(116, 116, 116, 0.3); pointer-events: auto;'
                }
            />
            <Name
                data-tip={itemData.name}
                data-for={`${itemData.value}-tooltip`}
                isSelected={props.isSelected}
            >
                {itemData.name}
            </Name>
        </components.Option>
    );
};
